import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'

const clinicPages = [
  {
    text: 'Training Modules',
    href: '/toolkit/clinics/training',
    description:
      'Access training materials for clinic staff on SCD management protocols.'
  },
  {
    text: 'Educational Resources',
    href: '/toolkit/clinics/educational-resources',
    description:
      'Find resources to enhance clinic operations and patient care for SCD.'
  },
  {
    text: 'Patient Specific Treatment Plans',
    href: '/toolkit/clinics/treatment-plans',
    description:
      'Utilize standardized treatment plan templates for SCD patients in clinic settings.'
  },
  {
    text: 'Extension for Community Health Outcomes (ECHO)',
    href: '/toolkit/clinics/echo',
    description:
      'Connect with specialists and peers through Project ECHO for clinic-based SCD care.'
  },
  {
    text: 'Common Elements of an Infusion Center',
    href: '/toolkit/clinics/common-elements',
    description:
      'Understand the key components and best practices for setting up and running an SCD infusion center.'
  },
  {
    text: 'List of Local Resources',
    href: '/toolkit/clinics/local-resources',
    description:
      'Access a curated list of local services and support for SCD patients and their families.'
  },
  {
    text: 'Patient Education Materials',
    href: '/toolkit/clinics/patient-education',
    description:
      'Provide patients with informative materials about managing their SCD.'
  },
  {
    text: 'Audit & Feedback',
    href: '/toolkit/clinics/audit-feedback',
    description:
      'Review tools and guides for auditing clinic practices and providing constructive feedback to staff.'
  },
  {
    text: 'Staff Review and Job Descriptions',
    href: '/toolkit/clinics/staff-reviews',
    description:
      'Access templates and resources for staff performance reviews and detailed job descriptions for clinic roles.'
  }
]

export const ClinicsSectionPage: React.FC = () => {
  return (
    <ToolkitPageLayout
      title="Clinic Resources"
      breadcrumbs={[
        { label: 'Toolkit', path: '/toolkit' },
        { label: 'Clinics', path: '/toolkit/clinics' }
      ]}
    >
      <div className="prose max-w-none text-[#3C2416] mb-8">
        <p className="text-xl">
          This section is designed to support clinics in providing high-quality
          care for individuals with Sickle Cell Disease (SCD). Here you&apos;ll
          find resources on training, operational guidelines, patient education,
          and more to help optimize your clinic&apos;s services and improve
          patient health journeys.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {clinicPages.map((page, index) => (
          <Link
            key={index}
            to={page.href}
            className="block p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 transition-colors duration-200 transform hover:scale-105"
          >
            <h5 className="mb-2 text-2xl font-bold tracking-tight text-[#142841]">
              {page.text}
            </h5>
            <p className="font-normal text-[#3C2416]">{page.description}</p>
          </Link>
        ))}
      </div>
    </ToolkitPageLayout>
  )
}
